export const parseInboxStage = (raw: string | undefined): number => ((/^[0-4]$/).test(raw ?? '') ? Number(raw) : 1);
